// components/QRCodeModal.tsx - Modal QR Code réutilisable
import React from 'react';
import { X, Download, QrCode } from 'lucide-react';

interface QRCodeModalProps {
    isOpen: boolean;
    onClose: () => void;
    qrCodeUrl: string;
    memberData: {
        first_name: string;
        last_name: string;
        member_number: string;
        referral_code: string;
    };
    onDownloadQR: () => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({
                                                     isOpen,
                                                     onClose,
                                                     qrCodeUrl,
                                                     memberData,
                                                     onDownloadQR
                                                 }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            <div
                className="bg-white p-8 rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-xl font-semibold text-gray-900">QR Code Membre</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-6 h-6"/>
                    </button>
                </div>

                {/* QR Code agrandi */}
                <div className="text-center mb-6">
                    {qrCodeUrl ? (
                        <img
                            src={qrCodeUrl.replace('300x300', '400x400')}
                            alt="QR Code Membre Agrandi"
                            className="w-full max-w-sm mx-auto border-2 border-gray-200 rounded-lg shadow-lg"
                            crossOrigin="anonymous"
                        />
                    ) : (
                        <div className="w-full max-w-sm h-64 bg-gray-100 rounded-lg flex items-center justify-center mx-auto">
                            <QrCode className="w-16 h-16 text-gray-400"/>
                        </div>
                    )}
                </div>

                {/* Informations */}
                <div className="bg-blue-50 p-4 rounded-lg mb-4">
                    <h4 className="font-semibold text-blue-800 mb-2">📱 Informations du membre</h4>
                    <div className="text-sm text-blue-700 space-y-1">
                        <p><strong>Nom :</strong> {memberData.first_name} {memberData.last_name}</p>
                        <p><strong>N° Membre :</strong> {memberData.member_number}</p>
                        <p><strong>Code de parrainage :</strong> {memberData.referral_code}</p>
                    </div>
                </div>

                {/* Bouton télécharger QR */}
                <button
                    onClick={onDownloadQR}
                    className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2"
                >
                    <Download className="w-5 h-5"/>
                    <span>Télécharger QR Code</span>
                </button>
            </div>
        </div>
    );
};

export default QRCodeModal;
